<div class="forgotPassword">
  <div class="container-fluid">
    <div class="row">
      <div class="shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1440 120"
        >
          <path
            d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"
          ></path>
        </svg>
      </div>

      <div class="DivOuter">
        <div class="forgotpass-panel">
          <div class="logo-panel">
            <img src="../../../../assets/images/ccs-logo.jpg" alt="csc" />
          </div>
          <h1>Forgot Your Password?</h1>
          <h3>
            Reset Password with
            <span>CORE Service+ Application</span>
          </h3>
          <div *ngIf="!resetPass" class="col resetPass">
            <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <div class="passrow">
                  <label for="password" class="required-field">Password</label>
                  <p-password
                    formControlName="password"
                    [toggleMask]="true"
                    inputStyleClass="form-control"
                  ></p-password>
                  <div class="ErrorMessageSection">
                    <p *ngIf="submitted && resetPasswordForm.get('password')?.hasError('required')">
                      Please enter password
                    </p>
                    <p
                      *ngIf="submitted && resetPasswordForm.get('password')?.hasError('maxlength')"
                    >
                      Password should be 30 characters or less.
                    </p>
                    <p
                      *ngIf="submitted && resetPasswordForm.get('password')?.hasError('minlength')"
                    >
                      Password must be at least 8 characters long.
                    </p>
                  </div>
                </div>
                <div class="passrow">
                  <label for="confirm-password" class="required-field">Confirm Password</label>
                  <p-password
                    formControlName="confirmPassword"
                    [toggleMask]="true"
                    inputStyleClass="form-control"
                  ></p-password>
                  <div class="ErrorMessageSection">
                    <p
                      *ngIf="
                        submitted && resetPasswordForm.get('confirmPassword')?.hasError('required')
                      "
                    >
                      Please enter confirm password
                    </p>
                    <p
                      *ngIf="
                        resetPasswordForm.get('confirmPassword')?.touched &&
                        resetPasswordForm.hasError('mismatch')
                      "
                    >
                      Password and Confirm Password do not match.
                    </p>
                  </div>
                </div>
              </div>

              <p-confirmPopup></p-confirmPopup>
              <button class="btn btn-info" type="button" (click)="generatePass($event)">
                Generate password
              </button>
              <button
                class="btn btn-success ml-3"
                type="submit"
                [disabled]="resetPasswordForm.pristine"
              >
                Submit
              </button>
            </form>
          </div>
          <div *ngIf="resetPass" class="col sent-reet-link">
            <div class="form-group">
              <p class="text-center text-success font-weight-bold">
                Your password has been reseted successfully. Please click the below link to login.
              </p>
              <div class="text-center">
                <button class="btn btn-success" type="button" (click)="gotoLogin()">Login</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
